import Joi from 'joi';

/**
 * Schema for leased billable event validation.
 */
export const leaseBillableEventsSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
